<template>
  <FlexLayout>
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true" loader="bars"></loading>

    <BlockContainer v-if="isChild" :title="$t('customerCard.subTitle.info')" :aria-label="$t('customerCard.subTitle.info')">
      <h3 class="normalText"><strong>{{ $t('customerCard.label.holder') }}:</strong> {{ fullName(wondCustomer) }}</h3>
      <h3 class="normalText"><strong>{{ $t('customerCard.label.number') }}:</strong> {{ wondCustomer.cardNum }}</h3>
      <h3 class="normalText"><strong>{{ $t('customerCard.label.balance') }}</strong> {{ wondCustomer.formattedPrepayBalanceCash }}</h3>
    </BlockContainer>
    <BlockContainer v-if="paymentDetails.length > 1" :title="$t('topUpPayment.subTitle.paymentMethods')" :aria-label="$t('topUpPayment.subTitle.paymentMethods')">
      <p>{{ $t('topUpPayment.label.choosePaymentMethod') }}</p>
      <template #actions>
        <Button v-for="payment in paymentDetails" :key="payment.code + (payment.subCode ? '~~' + payment.subCode : '')" @click="onSubmit(payment)"
          :aria-label="$t('topUpPayment.ariaLabel.choosePaymentMethod', [payment.name || payment.code])">
          {{ $t('topUpPayment.button.creditCard') }}
        </Button>
      </template>
    </BlockContainer>

    <component :is="currentPaymentComponent" :subCode="currentPaymentSubCode" :callback="redirectTo" v-if="currentPaymentComponent"></component>
  </FlexLayout>
</template>

<script>
import VueLoading from "vue-loading-overlay";
import { accountService } from "@/services/api/accountService";
import { paymentService } from "@/services/api/paymentService";
import { useAppStore } from "@/stores/app";
import { useTopUpRefreshStore } from "@/stores/topUpRefresh";
import { Workflow } from "@/constants/constants";
import CreditCardPaymentComponentSaferpay from "@/components/main-components/CreditCardPaymentComponentSaferpay.vue";
import CreditCardPaymentComponentSecurepay from "@/components/main-components/CreditCardPaymentComponentSecurepay.vue";
import CreditCardPaymentComponentNovalnet from "@/components/main-components/CreditCardPaymentComponentNovalnet.vue";
import CreditCardPaymentComponentPayone from "@/components/main-components/CreditCardPaymentComponentPayone.vue";
import CreditCardPaymentComponentAdyen from "@/components/main-components/CreditCardPaymentComponentAdyen.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import Button from "@/components/actions/Button.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";

export default {
  name: "top-up",
  components: {
    FlexLayout,
    Button,
    BlockContainer,
    loading: VueLoading,
    "credit-card-payment-saferpay": CreditCardPaymentComponentSaferpay,
    "credit-card-payment-securepay": CreditCardPaymentComponentSecurepay,
    "credit-card-payment-novalnet": CreditCardPaymentComponentNovalnet,
    "credit-card-payment-payone": CreditCardPaymentComponentPayone,
    "credit-card-payment-adyen": CreditCardPaymentComponentAdyen,
  },
  data() {
    return {
      isLoading: false,
      wondCustomer: {},
      paymentDetails: [],
      currentPaymentComponent: null,
      currentPaymentSubCode: ""
    };
  },
  setup() {
    return {
      appStore: useAppStore(),
      topUpRefreshStore: useTopUpRefreshStore(),
    };
  },
  computed: {
    isChild() {
      return this.appStore.isWorkflow(Workflow.SCHOOL);
    }
  },
  props: {
    customerId: [String, Number]
  },
  methods: {
    fullName(customer) {
      return [customer.description, customer.firstName].filter(Boolean).join(" ").trim();
    },
    async getPaymentDetails() {
      this.isLoading = true;
      const result = await paymentService.getPaymentMethods();
      this.isLoading = false;
      if (result.exception || !result.paymentDetails) {
        this.makeToast("danger", this.$t("topUpPayment.messages.error.onTopUp"));
        return;
      }
      this.paymentDetails = result.paymentDetails;
      if (this.paymentDetails.length === 1) {
        this.onSubmit(this.paymentDetails[0]);
      }
    },
    async onSubmit(payment) {
      this.isLoading = true;
      const paymentMethod = payment.subCode ? `${payment.code}~~${payment.subCode}` : payment.code;
      const result = await paymentService.pay(paymentMethod);
      this.isLoading = false;

      const paymentComponents = {
        Saferpay: "credit-card-payment-saferpay",
        Securepay: "credit-card-payment-securepay",
        Novalnet: "credit-card-payment-novalnet",
        PayOne: "credit-card-payment-payone",
        Adyen: "credit-card-payment-adyen"
      };

      this.currentPaymentComponent = paymentComponents[result.paymentMethod.split("~~")[0]] || null;
      this.currentPaymentSubCode = payment.subCode || "";
    },
    async redirectTo(status) {
      if (status >= 0) {
        if (this.isChild) {
          this.topUpRefreshStore.clear();
        } else {
          this.topUpRefreshStore.confirmPayment();
        }
        this.makeToast("success", this.$t("topUpPayment.label.chargeSuccess"));
        this.isChild ? this.$navigateToStudentAccounts(true) : this.$navigateToCustomerCard();
      } else {
        this.topUpRefreshStore.clear();
      }
    }
  },
  async created() {
    if (this.isChild) {
      this.wondCustomer = await accountService.selectChild(this.customerId);
    }
    await this.getPaymentDetails();
  }
};
</script>

<style scoped>
</style>
